import { FavoriteButtonWrapperContainer } from '@cian/favorites-assign-widget';
import { Button, TooltipDesktop } from '@cian/ui-kit';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TThunkDispatch } from '../../../../../../../shared/types/redux';

import { EAlertType, openAuthenticationModal } from '../../../../../../../shared/actions/authentication';
import { configSelector } from '../../../../../../../shared/selectors/configSelector';
import { ControlWrapper } from '../../../../components/ControlWrapper';
import { OfferContext } from '../../../../context';
import { TOfferContextData } from '../../../../types/offer-card';

export function FavoritesControlContainer() {
  const dispatch = useDispatch<TThunkDispatch>();
  const config = useSelector(configSelector);
  const {
    user: { isAuthenticated },
    offer,
    api: { onFavoritesChange },
  } = React.useContext(OfferContext) as TOfferContextData;
  const isPartnersFavoritesEnabled = Boolean(config.get<boolean>('dailyrent.partners_favorites.Enabled'));

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onFavoritesChange(!offer.isFavorite);
  };

  const handleLogin = React.useCallback(() => {
    dispatch(openAuthenticationModal({ autoRefresh: true, alert: EAlertType.Favorites }));
  }, [dispatch]);

  const button = (
    <TooltipDesktop theme="black" placement="left" title={offer.isFavorite ? 'В избранном' : 'Добавить в избранное'}>
      <Button
        data-mark="FavoritesControl"
        size="XS"
        theme="stroke_secondary"
        onClick={handleClick}
        beforeIcon={offer.isFavorite ? <IconToggleHeartOn16 color="icon-negative-default" /> : <IconToggleHeartOff16 />}
      />
    </TooltipDesktop>
  );

  if (offer.isCianPartner && !isPartnersFavoritesEnabled) {
    return null;
  }

  return (
    <ControlWrapper visible={true}>
      <FavoriteButtonWrapperContainer
        offerId={offer.cianId}
        placement="bottom-end"
        isAuthenticated={isAuthenticated}
        onWaitForLogin={handleLogin}
      >
        {button}
      </FavoriteButtonWrapperContainer>
    </ControlWrapper>
  );
}
